__turbopack_context__.v({
  "indicator": "styles-module__oEXHDG__indicator",
});
